import Vue from "vue";
import Vuex from "vuex";
import { AuthService } from "../services/auth-service";
import { RentalsService } from "../services/rentals-service-mock";
import { AdministrationService } from "../services/administration-service-mock";
import * as mutators from "./mutators";
import { AgileAPI } from "../../../BookingAPIClient/src/services/agile-api";
import { AutoleieAPI } from "../services/autoleie-api";

Vue.use(Vuex);

const state = {
    status: "",

    rentals: [],
    applications: [],
    locations: [],
    insurances: [],
    quote: {
        params: null,
        data: {
            items: [],
            specificGroupID: false
        },
        
    },
    // value for category options and catgegory selection from the CategoryFitler.vue component
    categoryOptions: [
        { text: 'STOR', value: 'STOR' },
        { text: 'KOMPAKT', value: 'KOMPAKT' },
        { text: 'SUV', value: 'SUV'},
        { text: 'LITEN', value: 'LITEN' },
        { text: 'STASJONSVOGN', value: 'STASJONSVOGN' },
        { text: 'FLERSETER', value: 'FLERSETER' },
        { text: 'VAREBIL', value: 'VAREBIL' ,disabled: true  }
    ],
    categorySelection: [],

    // value for seat options and seat selection from the SeatFitler.vue component
    seatOptions: [
        { text: '2', value: 2, disabled: true  },
        { text: '4', value: 4 },
        { text: '5 ', value: 5 },
        { text: '7', value: 7 },
        { text: '9', value: 9 },
        { text: '11', value: 11 },
    ],
    seatSelection: [],

    // value for gear options and gear selection from the GearFitler.vue component
    gearOptions: [
        { text: 'automatic', value: 'automatic' },
        { text: 'manual', value: 'manual' },
    ],
    gearSelection: [],

    // value for fuel options and fuel selection from the FuelFitler.vue component
    fuelOptions: [
        { text: 'petrol', value: 'petrol' },
        { text: 'diesel', value: 'diesel' },
        { text: 'electric', value: 'electric', disabled: true },
    ],
    fuelSelection: [],


    postBookingResult: null,
};

const mutations = {
    [mutators.AUTH_REGISTER](state) {
        state.status = "registering";
    },
    [mutators.AUTH_REGISTER_SUCCESS](state) {
        state.status = "success";
    },
    [mutators.RENTAL_GET](state) {
        state.status = "getting rentals";
    },
    [mutators.RENTAL_GET_SUCCESS](state, data) {
        state.status = "success";
        state.rentals = data;
    },
    [mutators.ADMINISTRATION_GET_APPLICATIONS_SUCCESS](state, data) {
        state.status = "success";
        state.applications = data;
    },
    [mutators.AGILE_GET_LOCATIONS_SUCCESS](state, data) {
        state.status = "success";
        state.locations = data;
    },
    [mutators.AUTOLEIE_GET_INSURANCES_SUCCESS](state, data) {
        state.status = "success";
        state.insurances = data;
    },
    [mutators.AUTOLEIE_GET_INSURANCES_FAIL](state, data) {
        state.status = "failed";
        state.insurances = data;
    },
    [mutators.AGILE_GET_QUOTES_SUCCESS](state, data) {
        state.status = "success";
        state.quote = data;
    },
    [mutators.AGILE_POST_BOOKING_SUCCESS](state, data) {
        state.status = "success";
        state.postBookingResult = data;
    },
    [mutators.AGILE_UPDATE_CATEGORY](state, data) {
        state.categorySelection = data;
    },
    [mutators.AGILE_SET_CATEGORY](state, data) {
        state.categoryOptions = data;
    },
    [mutators.AGILE_UPDATE_GEAR](state, data) {
        state.gearSelection = data;
    },
    [mutators.AGILE_SET_GEAR](state, data) {
        state.gearOptions = data;
    },
    [mutators.AGILE_UPDATE_SEAT](state, data) {
        state.seatSelection = data;
    },
    [mutators.AGILE_SET_SEAT](state, data) {
        state.seatOptions = data;
    },
    [mutators.AGILE_UPDATE_FUEL](state, data) {
        state.fuelSelection = data;
    },
    [mutators.AGILE_SET_FUEL](state, data) {
        state.fuelOptions = data;
    },
};

const actions = {
    async register({ commit }, user) {
        try {
            commit(mutators.AUTH_REGISTER);
            const result = await AuthService.register(user);
            if (result) {
                commit(mutators.AUTH_REGISTER_SUCCESS, result);
            }
        } catch (err) {
            commit(mutators.AUTH_ERROR);
        }
    },

    async getRentals({ commit }, ctx) {
        commit(mutators.RENTAL_GET);
        const data = await RentalsService.getRentals(ctx);
        commit(mutators.RENTAL_GET_SUCCESS, data);
    },
    async getApplications({ commit }) {
        const data = await AdministrationService.getApplications();
        commit(mutators.ADMINISTRATION_GET_APPLICATIONS_SUCCESS, data);
    },
    async getLocations({ commit }) {
        var data = [];
        try{
            data = await AgileAPI.getLocations();
        }catch(e){
            console.log("Error ", e);
        }

        // create google maps link to location based on longitude and langitude
        const url = "https://www.google.com/maps/search/?";

        for(let i=0; i<data.length; i++){
            if(data[i].latLon.lat !== 0 && data[i].latLon.lon !== 0){
                const params = new URLSearchParams();
                params.append("api",1);
                params.append("query", data[i].latLon.lat.toString() + "," + data[i].latLon.lon.toString());
                data[i].linkMap = url + params.toString();
            }else{
                data[i].linkMap = null;
            }
            
        }
        commit(mutators.AGILE_GET_LOCATIONS_SUCCESS, data);
    },
    async getInsurances({ commit }, userId) {
        try {
            const data = await AutoleieAPI.getInsurances(userId);
            commit(mutators.AUTOLEIE_GET_INSURANCES_SUCCESS, data);
        } catch (err) {
            commit(mutators.AUTOLEIE_GET_INSURANCES_FAIL, []);
        }
    },
    /**
     * Calles QuoteCollectionEndpoint to get the quotes based on locations and datetimes.
     * add as
     * 
     * @param {*} param0 
     * @param {*} quoteRequest 
     */
    async getQuotes ( { commit }, quoteRequest )
    {

        const data = await AgileAPI.getQuotes(quoteRequest);

        var quoteData = data;
        var numberSeats = new Set();
        var typeOfFuel = new Set();
        var typeOfGear = new Set();
        var typeOfCategory = new Set();

        //fetch all car images
        for(let itemObj of quoteData.items){
            // build image link based on the carId
            itemObj.image = [];
            for(let carId of itemObj.imageId){
                itemObj.image.push(process.env.VUE_APP_API_HOST_URL+"/booking/image?carId="+carId)
            }

            // get different number of seats
            numberSeats.add(itemObj.numberOfSeats);

            // get different fuels
            if(itemObj.typOfFuel === ""){
                itemObj.typOfFuel = "unkown"
            }
            typeOfFuel.add(itemObj.typOfFuel);

            // get different categories
            typeOfCategory.add(itemObj.category);

            // get different gears
            if(itemObj.typOfGear === ""){
                itemObj.typOfGear = "unkown"
            }
            typeOfGear.add(itemObj.typOfGear);
        }


        commit( mutators.AGILE_GET_QUOTES_SUCCESS, { params: quoteRequest, data: quoteData });
        
        //set seat option
        var seatOptions = [];
        for (const item of numberSeats.values()){
            seatOptions.push({text: item, value: item});
        }
        seatOptions.sort((a,b) => {
            if(a.value < b.value){
                return -1;
            }else if(a.value === b.value){
                return 0;
            }else{
                return 1;
            }
        })
        commit( mutators.AGILE_SET_SEAT, seatOptions)

        // set fuel options
        var fuelOptions = [];
        for (const item of typeOfFuel.values()){
            fuelOptions.push({text: item, value: item});
        }
        commit( mutators.AGILE_SET_FUEL, fuelOptions)

        // set gear options
        var gearOptions = [];
        for (const item of typeOfGear.values()){
            gearOptions.push({text: item, value: item});
        }
        commit( mutators.AGILE_SET_GEAR, gearOptions)

        // set category options
        var categoryOptions = [];
        for (const item of typeOfCategory.values()){
            categoryOptions.push({text: item, value: item});
        }
        commit( mutators.AGILE_SET_CATEGORY, categoryOptions)
    },

    async commitBooking({ commit }, booking) {
        const data = await AgileAPI.postBooking(booking);
        commit(mutators.AGILE_POST_BOOKING_SUCCESS, data);
    },


    /**
     * 
     * @param {*} param0 
     * @param {*} options category options for the component CategoryFitler.vue with text (category description), value (nId) and disabled (true or noting)
     */
    setCategoryOptions({ commit }, options) {
        /* example 
        [{ text: 'STOR', value: 1 },
        { text: 'KOMPAKT', value: 2 },
        { text: 'SUV ', value: 3, disabled: true },
        { text: 'LITEN', value: 4 },
        { text: 'STASJONSVOGN', value: 5 },
        { text: 'FLERSETER', value: 6 },
        { text: 'VAREBIL', value: 7 }]
        */
        commit(mutators.AGILE_SET_CATEGORY, options);
    },

    /**
     * 
     * @param {*} param0 
     * @param {*} selection category selection from the component CategoryFitler.vue 
     */
    setCategorySelction({ commit }, selection) {

        commit(mutators.AGILE_UPDATE_CATEGORY, selection);
    },

    setSeatOptions({ commit }, options) {
        commit(mutators.AGILE_SET_SEAT, options);
    },

    setSeatSelction({ commit }, selection) {

        commit(mutators.AGILE_UPDATE_SEAT, selection);
    },

    setGearOptions({ commit }, options) {
        commit(mutators.AGILE_SET_GEAR, options);
    },

    setGearSelction({ commit }, selection) {

        commit(mutators.AGILE_UPDATE_GEAR, selection);
    },

    setFuelOptions({ commit }, options) {
        commit(mutators.AGILE_SET_FUEL, options);
    },

    setFuelSelction({ commit }, selection) {

        commit(mutators.AGILE_UPDATE_FUEL, selection);
    },
};

const getters = {
    locations: (state) => state.locations,
    insurances: (state) => state.insurances,
    quote: (state) => state.quote,
    postBookingResult: (state) => state.postBookingResult,
    getCategoryOptions: (state) => state.categoryOptions,
    selectedGroup: (state) => state.categorySelection,
    getSeatOptions: (state) => state.seatOptions,
    selectedSeat: (state) => state.seatSelection,
    getGearOptions: (state) => state.gearOptions,
    selectedGear: (state) => state.gearSelection,
    getFuelOptions: (state) => state.fuelOptions,
    selectedFuel: (state) => state.fuelSelection,
    checkSpecificGroupId: (state) => state.quote.data.specificGroupID,
};

export default new Vuex.Store({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
});
